/* eslint-disable  @typescript-eslint/ban-ts-comment */
import './ChannelLineupTable.scss'
import { useEffect, useRef, useState } from 'react'

import Modal from '@cox/core-ui8/dist/Modal'
import RichText from '@cox/core-ui8/dist/RichText'
import { Spinner } from '@cox/core-ui8/dist/Spinner'

import { ChannelLineupTableProps } from './types'
import { getImageSrc } from '../../../utils/local-util'
import { ScreenSizes } from '../../../utils/types'
import ReactChannelLineup from '../ReactChannelLineup'
import { ChannelLineupLayout } from '../types'

const ChannelLineupTable = (props: ChannelLineupTableProps) => {
  const {
    channelLineupLayout = window.outerWidth < ScreenSizes.MD ? ChannelLineupLayout.MOBILE : ChannelLineupLayout.DESKTOP,
    channelCheckmarkIcon,
    channelCheckmarkIconAltText,
    optionalChannelLinkText,
    viewDetailsLinkText,
    viewDetailsModalTitle,
    viewDetailsModalPrimaryBtnText,
    sortChannelsOptionsTitle,
    lineupParams = {},
    lineupData = {},
    loadMoreData
  } = props

  const noOfColumns = lineupData?.tableHeader && Object.keys(lineupData?.tableHeader).length
  const tableContainerRef = useRef(null)
  let appendData = false
  const [loadAdditionalData, setLoadAdditionalData] = useState(false)

  const [tableData, setTableData] = useState<any>([])

  const handleScroll = () => {
    if (
      // @ts-ignore
      tableContainerRef?.current?.getBoundingClientRect()?.height -
        (channelLineupLayout === ChannelLineupLayout.MODAL
          ? 250
          : channelLineupLayout === ChannelLineupLayout.MOBILE
          ? 0
          : 100) <
        (channelLineupLayout === ChannelLineupLayout.MODAL
          ? document.getElementsByClassName('basic-modal-body-wrapper')[0].scrollTop
          : window.scrollY) &&
      !appendData &&
      lineupData?.totalResults > lineupParams?.end
    ) {
      appendData = true
      setLoadAdditionalData(true)
      loadMoreData && loadMoreData()
    }
  }

  useEffect(() => {
    const elementToAttachScrollListener =
      channelLineupLayout === ChannelLineupLayout.MODAL
        ? document.getElementsByClassName('basic-modal-body-wrapper')[0]
        : window

    elementToAttachScrollListener.addEventListener('scroll', handleScroll)

    return () => {
      elementToAttachScrollListener.removeEventListener('scroll', handleScroll)
    }
  }, [lineupData])

  useEffect(() => {
    const bodyData = lineupData?.tableBody.map((data: any, index: number) => {
      const { channelBox, checked, optional } = data

      let tdContent
      if (channelBox) {
        const { logoAlt, logoUrl, channelName, channelFeatures } = data
        channelLineupLayout !== ChannelLineupLayout.MODAL
          ? (tdContent = (
              <td key={`${channelBox}-${index}`}>
                <div className='channel-data'>
                  <h3 className='channel-box'>{channelBox}</h3>
                  <img className='channel-logo' alt={logoAlt} src={logoUrl} />
                  <div className='channel-name'>{channelName}</div>
                  <ul className='channel-features'>
                    {channelFeatures?.map((feature: any, index: any) => (
                      <li key={`${channelBox}-li-${index}`}>{feature.type}</li>
                    ))}
                    {!Array.isArray(channelFeatures) && <li key={`${channelBox}-li-${index}`}>{channelFeatures}</li>}
                  </ul>
                </div>
              </td>
            ))
          : (tdContent = (
              <>
                <td key={`modal-${channelBox}-${index}`}>
                  <div className='channel-data'>
                    <h3 className='channel-box'>{channelBox}</h3>
                    <img className='channel-logo' alt={logoAlt} src={logoUrl} />
                  </div>
                </td>
                <td key={`modal-${index}`}>
                  <div className='channel-name'>{channelName}</div>
                </td>
              </>
            ))
      } else if (checked) {
        tdContent = (
          <td key={index}>
            <img className='channel-checkmark' src={getImageSrc(channelCheckmarkIcon)} alt={channelCheckmarkIconAltText} />
          </td>
        )
      } else if (optional) {
        const optionalLink = `<a class='optional-link' href='#modal-optional-channel-${index}' data-link-type='modal'>
                ${optionalChannelLinkText}
              </a>`
        tdContent = (
          <>
            <td key={index} className='optional'>
              <RichText text={optionalLink} />
            </td>
            <Modal
              modalId={`modal-optional-channel-${index}`}
              show={false}
              title={` `}
              handleClose={() => handleModalClose(`modal-optional-channel-${index}`)}
              children={<RichText text={data.optionalText} />}
            />
          </>
        )
      } else {
        tdContent = <td key={index}>&nbsp;</td>
      }
      return tdContent
    })
    if (loadAdditionalData) {
      setTableData([...tableData, ...bodyData])
      setLoadAdditionalData(false)
    } else {
      setTableData(bodyData)
    }
  }, [lineupData])

  const getViewDetailsModalBody = (pkg: any) => {
    return (
      <div className='view-details-modal__body'>
        <ReactChannelLineup
          sortChannelsOptionsTitle={sortChannelsOptionsTitle}
          pkg={pkg}
          channelLineupLayout={ChannelLineupLayout.MODAL}
        />
      </div>
    )
  }

  const handleModalClose = (modalId: string) => {
    window.dispatchEvent(new CustomEvent('hideModal', { detail: { modalId: modalId, showModal: false } }))
  }

  const getViewDetailsModal = (pkg: any) => {
    const viewDetailsLink = `<a class='view-details' href='#${pkg}' data-link-type='modal'>${viewDetailsLinkText}</a>`
    return (
      <>
        <RichText text={viewDetailsLink} />
        <Modal
          modalId={pkg}
          show={false}
          title={viewDetailsModalTitle}
          showFooter={true}
          primaryBtnText={viewDetailsModalPrimaryBtnText}
          primaryBtnClick={() => handleModalClose(pkg)}
          handleClose={() => handleModalClose(pkg)}
          children={getViewDetailsModalBody(pkg)}
        />
      </>
    )
  }

  const tableHeader = lineupData?.tableHeader
  const desktopPageTable = tableHeader && channelLineupLayout !== ChannelLineupLayout.MODAL

  return (
    <>
      <div className={`channel-lineup__table`} data-testid='channel-lineup__table' ref={tableContainerRef}>
        <table className={`data-table--${channelLineupLayout}`}>
          <thead className={`thead--${channelLineupLayout}`}>
            <tr>
              {tableHeader?.map((data: any, index: number) => (
                <th key={index} className={data.colClass}>
                  {data.colTitle}
                  {data.colTitleSpan && <div>{data.colTitleSpan}</div>}
                </th>
              )) ?? <th>{lineupData?.packageName}</th>}
            </tr>
          </thead>
          <tbody>
            {desktopPageTable && (
              <tr>
                {tableHeader?.map((data: any, index: number) => {
                  return data.pkg ? (
                    <td key={`view-details-${index}`}>{getViewDetailsModal(data.pkg)}</td>
                  ) : (
                    <td key={`view-details-${index}`}>&nbsp;</td>
                  )
                })}
              </tr>
            )}
            {desktopPageTable
              ? tableData?.reduce((acc: any, item: any, index: number) => {
                  if (index % noOfColumns === 0) {
                    const newRow = []
                    for (let i = 0; i < noOfColumns; i++) {
                      const itemIndex = index + i
                      if (itemIndex < tableData.length) {
                        newRow.push(tableData[itemIndex])
                      } else {
                        newRow.push(<td key={`empty-data-${index}`}>&nbsp;</td>)
                      }
                    }
                    // @ts-ignore
                    acc.push(<tr key={`row-${index}`}>{newRow}</tr>)
                  }
                  return acc
                }, [])
              : tableData?.map((data: any, index: number) => {
                  return <tr key={index}>{data}</tr>
                })}
          </tbody>
        </table>
      </div>
      {loadAdditionalData && (
        <div className='react-channel-lineup__spinner'>
          <Spinner size='xl' />
        </div>
      )}
    </>
  )
}

export default ChannelLineupTable
